import { Trans } from '@lingui/react/macro'
import React, { Component, ErrorInfo } from 'react'
import { Loading } from './loading'
import { Button, Card } from '@tecsinapse/cortex-react'
import { MdOutlineSentimentDissatisfied } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { logger } from '../utils/logger'
import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { request } from '../utils/request'
import type { OpsQueryQuery } from '../types/graphql'

const OPS_QUERY = gql`
  query OpsQuery {
    menuUsuarioLogado {
      linkHelpTec
    }
  }
`

export const OpsErrorMessage = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['opsError'],
    queryFn: async () => await request<OpsQueryQuery>(OPS_QUERY)
  })

  if (isLoading) {
    return <Loading />
  }

  return (
    <div>
      <Card className={'flex flex-col space-y-mili items-center'}>
        <MdOutlineSentimentDissatisfied size={48} />
        <p className={'text-h1'}>Ops</p>
        <div className={'flex flex-row items-center space-x-mili'}>
          <p className={'text-h4'}>
            <Trans>
              Ocorreu um erro ao processar sua solicitação. Por favor, tente
              novamente. Persistindo o problema abra ticket no
            </Trans>
          </p>
          {error || !data || !data.menuUsuarioLogado ? (
            ' HelpTec'
          ) : (
            <Link
              to={data.menuUsuarioLogado.linkHelpTec ?? ''}
              className={'text-secondary-medium'}
            >
              HelpTec
            </Link>
          )}
        </div>

        <Button onClick={() => window.history.back()}>
          <Trans>Voltar</Trans>
        </Button>
      </Card>
    </div>
  )
}

type OpsErrorBoundaryProps = {
  children: React.ReactNode
}

type OpsErrorBoundaryState = {
  hasError: boolean
}

export class OpsErrorBoundary extends Component<
  OpsErrorBoundaryProps,
  OpsErrorBoundaryState
> {
  constructor(props: OpsErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): OpsErrorBoundaryState {
    return { hasError: true }
  }

  // React supplies ErrorInfo as part of the lifecycle contract; logging keeps the existing payload.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error({
      message: error.message,
      stack: error.stack
    })
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return <OpsErrorMessage />
    }

    return children
  }
}
